module.exports = __WEBPACK_EXTERNAL_MODULE_84__;


//////////////////
// WEBPACK FOOTER
// external "xes-frontend-ui/lib/utils/ajax"
// module id = 84
// module chunks = 4 5 10 11 12 13